import React, { useState } from 'react';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import app from '../firebase';

export default function Login() {
  const [email,setEmail]=useState(''), [pw,setPw]=useState('');
  const auth = getAuth(app);

  const submit = async e => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth,email,pw);
      await auth.currentUser.getIdToken(true);
      window.location.href = '/';
    } catch {
      alert('Login failed.');
    }
  };

  return (
    <div style={{display:'flex',height:'100vh',justifyContent:'center',alignItems:'center',background:'#f7f7f7'}}>
      <form onSubmit={submit} style={{background:'#fff',padding:40,borderRadius:16,boxShadow:'0 4px 12px rgba(0,0,0,0.1)'}}>
        <h2 style={{textAlign:'center',marginBottom:20}}>Pacio Portal Login</h2>
        <input type="email" placeholder="Email" value={email}
          onChange={e=>setEmail(e.target.value)}
          style={{display:'block',margin:'0 0 15px',padding:12,width:280,borderRadius:12,border:'1px solid #ccc'}}
          required
        />
        <input type="password" placeholder="Password" value={pw}
          onChange={e=>setPw(e.target.value)}
          style={{display:'block',margin:'0 0 20px',padding:12,width:280,borderRadius:12,border:'1px solid #ccc'}}
          required
        />
        <button type="submit" className="btn btn-primary" style={{width:'100%'}}>Login</button>
      </form>
    </div>
  );
}
